import { SEO } from "../components/SEO";
import { ProductCard } from "../components/ProductCard";
import { QuoteCTA } from "../components/CTA";
import { CATEGORIES, PRODUCTS } from "../data/site";

export default function Products() {
  return (
    <>
      <SEO title="Storage Solutions & Products | Pallet Racking, Shelving, Mezzanine — CustoRacks"
        description="Explore CustoRacks storage systems: pallet racking, shelving systems, slotted angle racks, mezzanine systems, cantilever racking, storage pallets and rack safety accessories." />
      <section className="page-hero" data-testid="products-hero">
        <div className="container">
          <div className="crumbs">Home / Products</div>
          <h1>Our Storage Solutions</h1>
          <p>Explore storage systems designed for different warehouse, industrial and commercial storage requirements.</p>
        </div>
      </section>
      {CATEGORIES.map((cat, i) => (
        <section className={i % 2 ? "section section-grey" : "section"} key={cat.id} data-testid={`category-${cat.id}`}>
          <div className="container">
            <div className="section-head">
              <span className="sec-label">{cat.name}</span>
              <h2>{cat.name}</h2>
              <p>{cat.blurb}</p>
            </div>
            <div className="grid-3">
              {PRODUCTS.filter((p) => p.category === cat.id).map((p) => <ProductCard key={p.slug} product={p} />)}
            </div>
          </div>
        </section>
      ))}
      <QuoteCTA title="Need Help Choosing the Right System?" text="Tell us about your storage requirement." />
    </>
  );
}
